import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { useWindowSize } from "@react-hook/window-size";
import { Row, Col, Input, FormGroup, Label, Button } from "reactstrap";
import Strip from "../customComponent/Strip/Strip";
import ExternalLayout from "../customComponent/ExternalLayout/ExternalLayout";
import RenderPage from "../customComponent/RenderPage/RenderPage";
import SEOComponent from "../customComponent/SEO/SEOComponent";
import CustomPagination from "./Home/CustomPagination";
import getPatients from "../../api/services/getPatients";
import application_contants from "../constants/application_contant";
import { NavLink } from "react-router-dom";


const Patientslist = () => {
  const [width] = useWindowSize();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setTotalPages] = useState(0); 
  const [totalPatients, setTotalPatients] = useState(0);
  const [totalPatients1, setTotalPatients1] = useState(0);
  const [totalPatients2, setTotalPatients2] = useState(0);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const response = await axios.get('http://15.207.223.68:5000/getPatientslist');
        setTotalPatients(response.data.totalPatients);
        const response1 = await axios.get('http://15.207.223.68:5000/getVisit');
        setTotalPatients1(response1.data.totalPatients);
        const response2 = await axios.get('http://15.207.223.68:5000/getHospital');
        setTotalPatients2(response2.data.totalPatients);
      } catch (error) {
        console.error('Error fetching patient data:', error);
      }
    };

    fetchPatients();
  }, []);
  

 
  return (
    <ExternalLayout>
      <RenderPage
        id="tst-landing"
        className={`render px-0 render-page`}
        containerType="container-fluid"
      >
        <Strip
          id="tst-strip-Video"
          className="strip strip-no-padding "
          containerType="container-fluid mb-5 mt-5"
        >
          <SEOComponent
            title="Home"
            keywords="Home"
            description="Antlia"
            siteUrl="/Antlia"
          />
          <Row className="mx-0 background-container container  pt-4 mx-5">
          <Col
              xs={11}
              sm={11}
              md={11}
              lg={11}
              xl={11}
              className="m-auto pt-5 pl-5"
            >
          <p className="p-small title-bold2 align-left">
                    <span className="p-small section-title title-bold1">
                      Home
                    </span>
                  </p>
                  </Col>
            <Col
              xs={11}
              sm={11}
              md={11}
              lg={11}
              xl={9}
              className="m-auto pt-3 pl-5"
            >
             
              <Row className="">
                <Col xs={12} sm={12} md={12} lg={12} xl={6} className="pt-4">
                
                <NavLink to="/Patients">
                    <Row className=" mx-0 ">
                      <Col
                        xs={12}
                        sm={12}
                        md={11}
                        lg={11}
                        xl={12}
                        className={`challenges-card-br5`}
                      >
                        <div className="pt-1">
                          <span className="p-large title-bold1 section-title2 title-black align-left mx-4 pl-2">
                          {totalPatients}
                          </span>
                          <div className="d-flex align-items-left justify-content-between ">
                            <div className="align-left ">
                              <p className="p-large section-title2 title-black pl-3 pt-3">
                                Patients
                              </p>
                            </div>
                            <div className="patients-icon pr-5">
                              <img
                                src={application_contants.patientsIcon}
                                alt="Patients Icon"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </NavLink>
              
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={6} className="pt-4">
                <NavLink to="/Test">
                    <Row className=" mx-0">
                      <Col
                        xs={12}
                        sm={12}
                        md={11}
                        lg={11}
                        xl={12}
                        className={`challenges-card-br5`}
                      >
                        <div className="pt-1">
                          <span className="p-large title-bold1 section-title2 title-black align-left mx-4 pl-2">
                          {totalPatients1}
                          </span>
                          <div className="d-flex align-items-left justify-content-between ">
                            <div className="align-left ">
                              <p className="p-large section-title2 title-black pl-4 pt-3">
                                Visits
                              </p>
                            </div>
                            <div className="patients-icon pr-5">
                              <img
                                src={application_contants.TestsIcon}
                                alt="Patients Icon"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </NavLink>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={6} className="pt-4">
                <NavLink to="/Hospital">
                    <Row className=" mx-0">
                      <Col
                        xs={12}
                        sm={12}
                        md={11}
                        lg={11}
                        xl={12}
                        className={`challenges-card-br5`}
                      >
                        <div className="pt-1">
                          <span className="p-large title-bold1 section-title2 title-black align-left mx-4 pl-2">
                          {totalPatients2}
                          </span>
                          <div className="d-flex align-items-left justify-content-between ">
                            <div className="align-left ">
                              <p className="p-large section-title2 title-black pl-3 pt-3">
                                Hospitals
                              </p>
                            </div>
                            <div className="patients-icon pr-5">
                              <img
                                src={application_contants.HospitalIcon}
                                alt="Patients Icon"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </NavLink>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={6} className="pt-4">
                <NavLink to="/devices">
                    <Row className=" mx-0">
                      <Col
                        xs={12}
                        sm={12}
                        md={11}
                        lg={11}
                        xl={12}
                        className={`challenges-card-br5`}
                      >
                        <div className="pt-1">
                          <span className="p-large title-bold1 section-title2 title-black align-left mx-4 pl-2">
                            4
                          </span>
                          <div className="d-flex align-items-left justify-content-between ">
                            <div className="align-left ">
                              <p className="p-large section-title2 title-black pl-3 pt-3">
                                Devices
                              </p>
                            </div>
                            <div className="patients-icon pr-5">
                              <img
                                src={application_contants.devicesIcon}
                                alt="Patients Icon"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </NavLink>
                </Col>
              </Row>
              <Row>
                <Col
                  Col
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={5}
                  className="pt-4"
                >
                  <div className="graph-icon">
                    <img src={application_contants.graph1} alt="" />
                  </div>
                </Col>
                <Col
                  Col
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={7}
                  className="pt-4"
                >
                  <div>
                    <img src={application_contants.graph2} alt="graph-icon" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Strip>
      </RenderPage>
    </ExternalLayout>
  );
};

export default Patientslist;
